'use client';

import dynamic from 'next/dynamic';

const AppInsightsInner = dynamic(
  () =>
    import('./AppInsightsClient').then((mod) => ({
      default: mod.AppInsightsClient,
    })),
  { ssr: false },
);

export const AppInsightsProvider = () => <AppInsightsInner />;
